import { useEffect } from 'react';
import { Add } from '@mui/icons-material';
import { Box, Button, Paper, Typography } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { Link, useParams } from 'react-router-dom';
import { useLeadInvoiceQuery } from '../../api/gql';
import { ConnectedInvoice } from '../../components/ConnectedInvoice';
import { PageLayout } from '../../layout/PageLayout';
import { LeadInvoiceDownloadButton } from '../../modules/pdf/LeadInvoiceDownloadButton';

export const DownloadPage = () => {
  const { invoiceId } = useParams();

  const formMethods = useForm();

  const { data } = useLeadInvoiceQuery({
    id: invoiceId ?? '',
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    data.leadInvoice ? formMethods.reset(data.leadInvoice) : null;
  }, [data, formMethods]);

  if (!invoiceId) {
    return <div>Invoice ID not found</div>;
  }

  return (
    <PageLayout>
      <Typography variant={'h1'} textAlign={'center'}>
        Zde je vaše faktura
      </Typography>
      <Box
        position={'relative'}
        display={'flex'}
        flexDirection={'column'}
        gap={6}
        mt={{ xs: 2, sm: 4, md: 6 }}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box
          flex={1}
          sx={{
            display: { xs: 'none', md: 'block' },
            zIndex: -1,
            position: 'absolute',
            opacity: 0.6,
            top: 0,
            right: 0,
            transform: 'scale(50%) translateY(-50%) rotate(25deg)',
          }}
        >
          <Paper
            sx={{
              width: '21cm',
              height: '29.7cm',
              p: { xs: 2, sm: 4, md: 6 },
            }}
          >
            <FormProvider {...formMethods}>
              <ConnectedInvoice readonly={true} />
            </FormProvider>
          </Paper>
        </Box>

        <LeadInvoiceDownloadButton invoiceId={invoiceId} />
        <Button component={Link} to={'/'} startIcon={<Add />}>
          Založit novou fakturu
        </Button>
      </Box>
    </PageLayout>
  );
};
